<template>
  <!-- 厂商应急保电订单列表 -->
  <div class="order">
    <div class="tabbar">
      <el-button
        type="primary"
        size="mini"
        v-for="(item, index) in category"
        :key="index"
        :plain="index != categoryIndex"
        @click="changeTable(index)"
      >
        {{ item.name }}
          ({{item.id==null?buttonSize.csyjnull:item.id==71?buttonSize.csyj71
          :item.id==1?buttonSize.csyj1
              :item.id==2?buttonSize.csyj2
                  :item.id==3?buttonSize.csyj3
                      :item.id==4?buttonSize.csyj4
                          :item.id==5?buttonSize.csyj5
                              :item.id==6?buttonSize.csyj6
                                  :item.id==7?buttonSize.csyj7
                                      :item.id==11?buttonSize.csyj11
                                          :item.id==18?buttonSize.csyj18
                                              :item.id==28?buttonSize.csyj28
                                                  :item.id==29?buttonSize.csyj29
                                                      :item.id==8?buttonSize.csyj8
                                                          :item.id==9?buttonSize.csyj9
                                                              :item.id==60?buttonSize.csyj60:0
          }})
      </el-button>
    </div>
      <div class="btnGroup" style="margin-left: 30px">

          <el-input v-model="queryParams.projectname" placeholder="请输入工程名称" clearable @keyup.enter.native="getOrderList1"
                    style="width: 200px;" />
          <el-button type="primary" plain style="margin-left: 10px;" @click="getOrderList1">查询
          </el-button>

      </div>
    <div class="table">
      <el-table :data="tableData" stripe>
        <el-table-column
          type="index"
          label="序号"
          align="center"
          :index="count"
        ></el-table-column>
        <el-table-column prop="name" label="订单信息" align="center">
          <template slot-scope="scope">
            <div class="table-order-status">
              <span>{{
                scope.row.vArray == 2
                  ? scope.row.orderNo + "合并订单"
                  : scope.row.orderNo
              }}</span>
              <span v-if="scope.row.status == 60 || scope.row.other == 60"
                >(续)</span
              >
            </div>
          </template>
        </el-table-column>
          <el-table-column label="工程名称" align="center" prop="projectname" />
          <el-table-column label="客户信息" align="center" prop="masterName" />
        <!-- <el-table-column prop="orderNo" label="订单号"></el-table-column> -->
        <el-table-column
          prop="time"
          label="开始时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="price"
          label="租赁价格"
          align="center"
        ></el-table-column>
          <el-table-column align="center" label="当前状态" prop="desc">
              <template slot-scope="scope">
 <span>
            {{scope.row.status == 0 ? '未确认提交': scope.row.status == 1 ? '待厂商确认' : scope.row.status == 2 ? '待平台签约'
     : scope.row.status == 3 ? '待客户支付租金' : scope.row.status == 4 ? '待厂商确认收款并发货'
         : scope.row.status == 6 ? '待客户收货'
             : scope.row.status == 7 ? '待厂商确认用电完成' : scope.row.status == 11 ? '待客户确认用电完成'
                 : scope.row.status == 18 ? '待平台出具结算单' : scope.row.status == 28 ? '待厂商结算'
                     : scope.row.status == 29 ? '待客户收款': scope.row.status == 8 ? '已完成'
                         : scope.row.status == 9 ? '已评价': scope.row.status == 60 ? '待厂商确认续费'
                             : scope.row.status == 70 ? '中止订单':'其他'}}
          </span>
                  <span v-if="(scope.row.status==8||scope.row.status==29||scope.row.status==9)&&scope.row.serviceFeeStatus==1">(待收取服务费)</span>
                  {{scope.row.status==7&&scope.row.other!=60?"(可续费)":''}}
                  <!--						<div class="time-line">-->
                  <!--							<div class="count">{{ getStatus(scope.row.orderSatus,scope.row.equipmentModel) }}</div>-->
                  <!--						</div>-->
              </template>
          </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope">
            <slot :row="scope.row" :column="scope.column">
              <div class="scope-button" style="justify-content: center">
                <div
                  class="scope-button-item scope-button-blue"
                  @click="hanldeCheck(scope.row)"
                >
                  <i class="el-icon-search"></i>
                  查看
                </div>
                <!-- <div class="scope-button-item scope-button-blue" @click="hanldeConfirm(scope.row)" v-if="scope.row.status==1">
									<i class="el-icon-check"></i>
									确认
								</div> -->
              </div>
            </slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      style="
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        padding-bottom: 20px;
      "
      v-if="total > query.pageSize"
    >
      <el-pagination
        background
        layout="prev, pager, next,total"
        :total="total"
        :page-size="query.pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
    equOrderList,
    delOrder,
    updateOrder, getButtonSizeApi,
} from "../../http/factory/add-eme.js";
export default {
  name: "order",
  data() {
    return {
      category: [
        {
          id: null,
          name: "全部状态",
        },
        {
          id: 1,
          name: "待厂商确认",
        },
        {
          id: 2,
          name: "待平台签约",
        },
        {
          id: 3,
          name: "待客户支付租金",
        },
        {
          id: 4,
          name: "待厂商确认收款并发货",
        },
        {
          id: 6,
          name: "待客户收货",
        },
        {
          id: 7,
          name: "待厂商确认用电完成",
        },
        {
          id: 11,
          name: "待客户确认用电完成",
        },
        {
          id: 18,
          name: "待平台出具结算单",
        },
        {
          id: 28,
          name: "待厂商结算",
        },
        {
          id: 29,
          name: "待客户收款",
        },
        {
          id: 8,
          name: "已完成",
        },
        {
          id: 9,
          name: "已评价",
        },
        {
          id: 60,
          name: "待厂商确认续费",
        },
        {
          id: 71,
          name: "待平台收取服务费",
        },
      ],
      categoryIndex: 0,
        queryParams:{
            projectname:null,
        },
      tableData: [],
      query: {
        pageSize: 15,
        pageNum: 1,
        status: null,
      },
      total: 0,
        buttonSize:[],
    };
  },
  methods: {
    count(index) {
      return (this.query.pageNum - 1) * this.query.pageSize + index + 1;
    },
    changeTable(index) {
      this.categoryIndex = index;

      this.currentPage = 1;
      this.fetchData();
    },
    hanldeCheck(row) {
      this.$router.push({
        path: "/factoryUser/factoryDetailEme",
        query: {
          id: row.id,
        },
      });
    },
    getStatus(status, equipmentModel) {
      for (let item of this.category) {
        if (status == 28) {
          if (equipmentModel == 2) {
            return "已完成";
          } else {
            return "已结算（待确认收款）";
          }
        }
        if (item.id == status) {
          return item.name;
        }
      }
    },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.fetchData();
    },
      getOrderList1(){
          this.query.pageNum=1;
          this.fetchData();
      },
      getButtonSize(){
          getButtonSizeApi({
              orderType: 1,
              superType: -1,
              projectname:this.queryParams.projectname,
          }).then(response=>{
              // console.log(response)
              this.buttonSize=response;
          })
      },
    fetchData() {
      let data = {
        pageSize: this.query.pageSize,
        pageNum: this.query.pageNum,
        orderType: 1,
          projectname:this.queryParams.projectname,
        orderSatus: this.category[this.categoryIndex]["id"],
        superType: -1,
      };
      equOrderList(data).then((res) => {
        let list = res.rows;
        let array = new Array();
        for (let i = 0; i < list.length; i++) {
          let name = list[i].title;
          if (list[i].serviceFeeRefund == 2) {
            let name_arr = [];
            for (let item of JSON.parse(list[i].equipmentList)) {
              name_arr.push(item.title);
            }
            name = "合并订单" + name_arr.join(",");
          }
          let obj = {
            orderNo: list[i].orderNo,
            name: list[i].title,
            time: list[i].startTime,
            price: "¥" + list[i].advance,
            status: list[i].orderSatus,
            other: list[i].status,
              paymentVoucher:list[i].paymentVoucher,
            id: list[i].id,
            equipmentModel: list[i].equipmentModel,
            serviceFeeRefund: list[i].serviceFeeRefund,
              serviceFeeStatus: list[i].serviceFeeStatus,
              masterName:list[i].masterName,
              projectname:list[i].projectname
          };
          array.push(obj);
        }
        this.tableData = array;

          for (var i = 0; i < this.tableData.length; i++) {
              if(this.tableData[i].paymentVoucher===null){
                  this.tableData[i].vArray=0;
              }else{
                  this.tableData[i].vArray=this.tableData[i].paymentVoucher.split(',').length;
              }
          }
        this.total = res.total;
      });
      this.getButtonSize()
    },

    hanldeConfirm(row) {
      updateOrder({
        id: row.id,
        orderSatus: 2,
      }).then((res) => {
        this.$message({
          message: "确认成功",
          type: "success",
        });
        this.fetchData();
      });
    },
    hanldeRefuse(row) {
      delOrder({
        id: row.id,
      }).then((res) => {
        this.$message({
          message: "取消订单成功！",
          type: "success",
          duration: 2000,
        });
        this.fetchData();
      });
    },
  },
    // created() {
    //     this.fetchData();
    // },
    mounted: function () {
    //模板编译/挂载之后
    if (this.$route.query.index != undefined) {
      this.changeTable(this.$route.query.index);
    } else {
      this.fetchData();
    }
  },
};
</script>

<style lang="less" scoped="scoped">
.order {
  width: 100%;
  background: @vue-bg-color;

  .tabbar {
    width: 100%;
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    padding: 20px @vue-spacing-row-base;
    box-sizing: border-box;

    .el-button {
      margin-top: 10px;
      margin-left: 10px;
    }
  }

  .table {
    min-height: 600px;
    width: 100%;
    padding: @vue-spacing-col-base @vue-spacing-row-base;
    box-sizing: border-box;

    .table-order-status {
      span {
        color: @vue-text-color-red;
      }
    }
  }

  .page-pager {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }
}
</style>
